import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_there_an_onsite_canteeneating_area'

export const dataPointDefinition = {
  retracedId: 'is_there_an_onsite_canteeneating_area',
  name: 'Is there an on-site canteen/eating area?',
  description:
    'Refers to a designated space for workers to eat meals. These meals can either be provided by a canteen (managed by the facility or by a third party service provider) or meals can be brought in from outside the facility to be eaten in a designated eating area.\r\r\nEating area means there is no kitchen where facility staff or other staff cook or prepare meals.\r\r\nCanteen means there is cooking or meal preparation by facility staff or third-party service providers. \r\r\nPlease see the answer options to determine what the facility has: only a canteen, only an eating area, both, or neither one. ',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes. Onsite eating area only.',
      key: 'YES_ONSITE_EATING_AREA_ONLY',
      slcpIndex: 1,
      slcpOptionName: 'canteen-list',
    },
    {
      name: 'Yes. Onsite canteen only.',
      key: 'YES_ONSITE_CANTEEN_ONLY',
      slcpIndex: 2,
      slcpOptionName: 'canteen-list',
    },
    {
      name: 'Yes. Onsite canteen and eating area.',
      key: 'YES_ONSITE_CANTEEN_AND_EATING_AREA',
      slcpIndex: 3,
      slcpOptionName: 'canteen-list',
    },
    {
      name: 'No. No onsite canteen or eating area.',
      key: 'NO_NO_ONSITE_CANTEEN_OR_EATING_AREA',
      slcpIndex: 4,
      slcpOptionName: 'canteen-list',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: [
          'YES_ONSITE_EATING_AREA_ONLY',
          'YES_ONSITE_CANTEEN_ONLY',
          'YES_ONSITE_CANTEEN_AND_EATING_AREA',
          'NO_NO_ONSITE_CANTEEN_OR_EATING_AREA',
        ],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bs-7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 840,
  sectionId: '2.2.9.11',
  impactArea: 'Canteens',
  impactAreaId: 'CANTEENS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
